<p-table
  [value]="items"
  [loading]="localLoading()"
>
  <ng-template #header>
    <tr>
      @for (column of columns; track $index) {
        <th
          [class]="column.align + ' text-sm'"
          [ngClass]="{ 'cursor-pointer': column.sortable }"
          (click)="column.sortable && sort(column.slug)"
        >
          {{ column.label }}
          @if (pageControl.orderField === column.slug) {
            @if (pageControl.order === order.ASC) {
              <i class="fa-solid fa-arrow-up"></i>
            }
            @if (pageControl.order === order.DESC) {
              <i class="fa-solid fa-arrow-down"></i>
            }
          }
        </th>
      }
    </tr>
  </ng-template>
  <ng-template #emptymessage>
    <tr>
      <td colspan="4" class="text-center">
        <div class="h-44 p-4 text-zinc-500">
          <ng-lottie [options]="emptyLottieOptions" />
          Nenhum registro encontrado.
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template #body let-item>
    <tr>
      <td>{{ item?.name | role }}</td>

      <td>{{ item?.users_count || 0 }}</td>

      <td>{{ item?.created_at | date: 'dd/MM/y' }}</td>

      <td>
          <div
            class="cursor-pointer w-fit"
            pTooltip="Editar"
            tooltipPosition="bottom"
            (click)="edit.emit(item); $event.stopPropagation()"
          >
            <i class="fa-regular fa-pen-to-square"></i>
          </div>
      </td>
    </tr>
  </ng-template>
 <ng-template #footer>
   <tr>
     <td colspan="4">
        <div class="w-full flex justify-end">
          <p-paginator
            (onPageChange)="onPageChange($event)"
            [rows]="pageControl.take"
            [totalRecords]="pageControl.itemCount"
            [showCurrentPageReport]="true"
            [rowsPerPageOptions]="[10, 25, 50]"
            currentPageReportTemplate="{first} - {last} de {totalRecords}"
            appendTo="body"
          />
        </div>
     </td>
   </tr>
 </ng-template>
</p-table>
